import React from 'react';

import NewFeature16Icon from '@atlaskit/icon-object/glyph/new-feature/16';

export default (): React.JSX.Element => <NewFeature16Icon label="" />;
